/* =========================================================================
   Amortisationsrechner (sections/amortization-calculator.liquid)

   Dieselbe Formel wie assets/calculator.js (Ertragsrechner der Produktseite):
   Jahresertrag = kWp × Ertragsfaktor, Nutzen = Eigenverbrauch × Strompreis
   + Einspeisung × Verguetung, mit Degradation und Strompreissteigerung
   Jahr fuer Jahr fortgeschrieben. Unterschied: Eingabe in Wp, Speicher-
   Schalter, und alle Felder werden ueber data-a / data-r innerhalb des
   eigenen [data-amort]-Elements gesucht statt ueber globale IDs.

   Fehlt ein Feld (kompakte Variante), gilt der Startwert aus den
   data-Attributen des Wurzelelements. Die Liquid-Beispielrechnung in der
   Section muss mit calc() uebereinstimmen – bei Aenderungen beide anpassen.
   ========================================================================= */
(function () {
  var CO2_PER_KWH = 0.38, HORIZON = 20, MAXSEARCH = 40;

  function de(n, digits) {
    return n.toLocaleString('de-DE', { minimumFractionDigits: digits || 0, maximumFractionDigits: digits || 0 });
  }

  /* Reine Rechnung, ohne DOM – auch per node pruefbar. */
  function rechne(p) {
    var gen1 = p.wp / 1000 * p.yieldK;
    var self = Math.min(1, Math.max(0, p.selfPct / 100));
    var selfBase = Math.min(1, Math.max(0, p.selfBasePct / 100));
    var save1 = gen1 * self * p.priceCt / 100;
    var feed1 = gen1 * (1 - self) * p.feedCt / 100;
    var total1 = save1 + feed1;
    var base1 = gen1 * selfBase * p.priceCt / 100 + gen1 * (1 - selfBase) * p.feedCt / 100;

    var cum = 0, payback = Infinity, profit = -p.cost;
    var gen = gen1, price = p.priceCt;
    for (var t = 1; t <= MAXSEARCH; t++) {
      var benefit = gen * self * price / 100 + gen * (1 - self) * p.feedCt / 100;
      var prev = cum; cum += benefit;
      if (payback === Infinity && cum >= p.cost && benefit > 0) payback = (t - 1) + (p.cost - prev) / benefit;
      if (t <= HORIZON) profit += benefit;
      gen *= 1 - p.degr / 100;
      price *= 1 + p.inc / 100;
    }
    return { gen1: gen1, save1: save1, feed1: feed1, total1: total1, diff1: total1 - base1, payback: payback, profit: profit, co2: gen1 * CO2_PER_KWH };
  }

  function init(root) {
    var q = function (k) { return root.querySelector('[data-a="' + k + '"]'); };
    var r = function (k) { return root.querySelector('[data-r="' + k + '"]'); };
    var num = function (k, def) {
      var el = q(k);
      var raw = el ? el.value : def;
      var v = parseFloat(String(raw).replace(',', '.'));
      return isFinite(v) ? v : parseFloat(def) || 0;
    };
    var d = root.dataset;

    /* Zahlenfeld und Regler gegenseitig nachziehen. */
    ['wp', 'cost', 'price', 'feed'].forEach(function (k) {
      var n = q(k), g = q(k + '-range');
      if (!n || !g) return;
      n.addEventListener('input', function () { g.value = Math.min(+g.max, Math.max(+g.min, parseFloat(n.value) || +g.min)); calc(); });
      g.addEventListener('input', function () { n.value = g.value; calc(); });
    });
    ['yield', 'self', 'self-storage', 'degr', 'inc'].forEach(function (k) {
      var el = q(k); if (el) el.addEventListener('input', calc);
    });

    /* Ausrichtung setzt den Ertragsfaktor; ein eigener Wert stellt die
       Auswahl auf „Eigener Wert". */
    var orient = q('orient'), yieldEl = q('yield');
    if (orient && yieldEl) {
      orient.addEventListener('change', function () {
        if (orient.value !== 'eigen') yieldEl.value = orient.value; else {
          var det = yieldEl.closest('details'); if (det) det.open = true;
          yieldEl.focus();
        }
        calc();
      });
      yieldEl.addEventListener('input', function () {
        var match = Array.prototype.some.call(orient.options, function (o) { return o.value === String(parseFloat(yieldEl.value)); });
        orient.value = match ? String(parseFloat(yieldEl.value)) : 'eigen';
      });
    }

    /* Speicher-Schalter: die Kosten wechseln mit, solange der Besucher sie
       nicht selbst geaendert hat (Feld steht noch auf dem anderen Startwert). */
    var storage = q('storage');
    if (storage) storage.addEventListener('change', function () {
      var cost = q('cost'), cr = q('cost-range');
      var from = storage.checked ? d.costOhne : d.costMit;
      var to = storage.checked ? d.costMit : d.costOhne;
      if (cost && parseFloat(cost.value) === parseFloat(from)) {
        cost.value = Math.round(parseFloat(to));
        if (cr) cr.value = cost.value;
      }
      calc();
    });

    function calc() {
      var mit = !!(storage && storage.checked);
      var selfOhne = num('self', d.self), selfMit = num('self-storage', d.selfStorage);
      var res = rechne({
        wp: Math.max(0, num('wp', 500)),
        cost: Math.max(0, num('cost', d.costOhne)),
        priceCt: Math.max(0, num('price', d.price)),
        feedCt: Math.max(0, num('feed', d.feed)),
        yieldK: Math.max(0, num('yield', d.yield)),
        selfPct: mit ? selfMit : selfOhne,
        selfBasePct: selfOhne,
        degr: Math.max(0, num('degr', d.degr)),
        inc: Math.max(0, num('inc', d.inc))
      });

      var hint = q('self-hint');
      if (hint) hint.textContent = 'Eigenverbrauch ' + de(mit ? selfMit : selfOhne) + ' % des erzeugten Stroms';

      if (!isFinite(res.payback) || res.total1 <= 0) {
        r('payback').innerHTML = '&gt; ' + MAXSEARCH + ' <small>Jahre</small>';
        r('payback-sub').textContent = 'Mit diesen Werten nicht wirtschaftlich';
        r('bar').style.width = '100%';
      } else {
        var whole = Math.floor(res.payback), months = Math.round((res.payback - whole) * 12);
        if (months === 12) { whole++; months = 0; }
        r('payback').innerHTML = de(res.payback, 1) + ' <small>Jahre</small>';
        r('payback-sub').textContent = '≈ ' + whole + ' Jahre' + (months ? ' ' + months + ' Monate' : '');
        r('bar').style.width = Math.min(100, res.payback / HORIZON * 100) + '%';
      }
      r('kwh').textContent = de(res.gen1) + ' kWh';
      r('self').textContent = de(res.save1) + ' €';
      r('feed').textContent = de(res.feed1) + ' €';
      r('total').textContent = de(res.total1) + ' €';
      r('storage-row').hidden = !mit;
      r('diff').textContent = (res.diff1 >= 0 ? '+' : '−') + de(Math.abs(res.diff1)) + ' €';
      r('profit20').textContent = (res.profit >= 0 ? '+' : '−') + de(Math.abs(res.profit)) + ' €';
      r('co2').textContent = de(res.co2) + ' kg';
    }

    calc();
  }

  if (typeof module !== 'undefined' && module.exports) { module.exports = { rechne: rechne }; return; }

  function start() { document.querySelectorAll('[data-amort]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
